import { useResponsiveMobile } from "../../../hooks/useResponsiveMobile";

export const Section8 = () => {
  const isMobile = useResponsiveMobile(900);
  return (
    <section className="flex flex-col gap-[40px] justify-center py-[100px] md:bg-[#F2F4F8] md:items-center px-4">
      {isMobile ? (
        <span className="text-center font-bold text-[36px] text-[#121319]+">
          번거로운 작업 없이
          <br /> 한 번에 관리하세요
        </span>
      ) : (
        <span className="text-center font-bold text-[36px] text-[#121319]+">
          복잡한 정산 업무도 손쉽게 <br /> 번거로운 작업 없이 한 번에 관리하세요
        </span>
      )}
      <div className="w-full overflow-x-auto md:overflow-x-visible">
        <div className="min-w-max md:min-w-0 flex justify-center">
          <img
            loading="lazy"
            src={
              isMobile ? "/assets/images/home/table_mobile.png" : "/assets/images/home/table.svg"
            }
            alt="eg1"
            className="h-auto w-[616px] md:w-full md:max-w-[1600px]"
            draggable={false}
          />
        </div>
      </div>
    </section>
  );
};
